import { useRef, useState } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { TextField } from '@mui/material';
import { MobileDateTimePicker } from '@mui/x-date-pickers';
import { dateTimeFormatter } from '../../utils/';
import { dateTimeConstants } from '../../constants';
import DropdownIcon from '../../images/icons/dropdown-arrow.svg';
import { Image } from 'react-bootstrap';

const DateTimePickers = ({due_date, dueDateInitialize,  input: { value: omitValue, onChange, onBlur, ...inputProps },meta: omitMeta,touched, error,...props}) => {
  const [value, setValue] = useState( due_date ? new Date(dueDateInitialize) : null);
  const [active, setActive] = useState(false);
  const buttonRef = useRef(null);
  const handleChange = (value) => {
    setValue(value)
    onChange(value)
  }

  const handleClose = () =>{
    setActive(false)
  }

  const handleOpen = () =>{
    setActive(true)
  }

  // TODO: format 'MMM DD, YYYY hh:mma' is not supported by the package
  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <MobileDateTimePicker
          open={ active }
          value={value}
          onAccept={(newValue) => handleChange(newValue)}
          renderInput={(params) => <TextField {...params} />}
          onClose={ handleClose }
          format={dateTimeConstants.DISPLAY_FORMAT}
          slotProps={{
            textField: {
              InputProps: {}
            },
            popper: { anchorEl: buttonRef.current },
            actionBar: {
              actions: ['clear', 'accept']
            }
          }}
        />
      </LocalizationProvider>

      <div
        className="cursor-pointer w-100 detail form-control d-flex justify-content-between align-items-center"
        onClick={handleOpen}
        ref={buttonRef}
      >
        {value ? dateTimeFormatter(value) : '-'}

        <Image src={DropdownIcon} height={'8'} width={'8'} className="dropdown-icon"/>
      </div>
    </>
  )
}

export default DateTimePickers
